export default __webpack_public_path__ + "static/media/budhaLogo.d51f62a7.png";